module.exports = __webpack_public_path__ + "static/9-529b171d21467d39425d65624988ee66.jpg";